export const CONFIGURATIONS_CHATBOT_EDITED = 'configurations-chatbot-edited';
export const CONFIGURATIONS_CHATBOT_DELETED = 'configurations-chatbot-deleted';
export const CONFIGURATIONS_BASICS_OPENED = 'configurations-basics-opened';
export const CONFIGURATIONS_WELCOME_SCREEN_OPENED = 'configurations-welcome-screen-opened';
export const CONFIGURATIONS_CONNECTION_INFO_OPENED = 'configurations-connection-info-opened';
export const CONFIGURATIONS_CONNECTION_BUILDER_TOGGLED = 'configurations-connection-builder-toggled';
export const CONFIGURATIONS_CONNECTION_SDK_TOGGLED = 'configurations-connection-SDK-toggled';
export const CONFIGURATIONS_CONNECTION_HTTP_TOGGLED = 'configurations-connection-HTTP-toggled';
export const CONFIGURATIONS_KEY_VIEW_OPENED = 'configurations-keys-view-opened';
export const CONFIGURATIONS_KEY_INFO_OPENED = 'configurations-keys-info-opened';
export const CONFIGURATIONS_KEY_ITEM_CREATED = 'configurations-keys-item-created';
export const CONFIGURATIONS_KEY_ITEM_VALUE_COPIED = 'configurations-keys-item-value-copied';
export const CONFIGURATIONS_KEY_ITEM_DELETED = 'configurations-keys-item-deleted';
export const DELETE_CHATBOT = 'delete-chatbot';
export const CONFIGURATIONS_MIMETYPE_OPENED = 'configurations-mimetype-opened';
